export enum AddressFormFieldNames {
  Address = 'address',
  AdditionalAddress = 'additionalAddress',
  PostalCode = 'postalCode',
  City = 'city',
  Country = 'country',
  GooglePlaceId = 'googlePlaceId',
  Latitude = 'latitude',
  Longitude = 'longitude'
}
